<template>
  <component :is="layout">
    <RouterView />
  </component>
</template>

<script>
const default_layout = "default";
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    }
  }
}
</script>

<style>
.main {
  /* haut | droit | bas | gauche */
  margin: 1rem 1em 1rem 3rem;
}
thead, tbody, tfoot, td, th {
    border-color: transparent !important;
}
tr {
  border-top: 1px solid #4e73df !important;
}
</style>
